<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-营养认知评估
-->

<template>
  <div class="bodyinfo-page">
    <div class="title">生活方式调查</div>
    <div class="form-wrapper">
      <van-form @submit="onSubmit" :scroll-to-error="true">
        <div class="form-item" v-for="item in qsList" :key="item.name">
          <div class="form-item-label">{{ item.label }}</div>
          <div class="form-item-input">
            <van-field :name="item.name" :rules="[{ required: true, message: '请选择' }]">
              <template #input>
                <van-radio-group v-model="formData[item.name]" direction="vertical" icon-size="1.33rem">
                  <van-radio class="van-radio__label"  name="1"
                    checked-color="#FBB13D">是</van-radio>
                    <van-radio class="van-radio__label"  name="0"
                    checked-color="#FBB13D">否</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </div>


        <div class="next-btn-wrapper">
          <van-button round block color="#FBB13D" native-type="button" plain @click="onClickPrev">上一页</van-button>
          <van-button round block color="#FBB13D" type="info" native-type="submit">下一页</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
// import {getQueryString} from '../utils/utils'
export default {
  name: 'ListStyleForm',
  props:{
    initdata: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      qsList: [{
        label: '1.是否定时定量用餐（进餐规律，无暴饮暴食）？',
        name: 'sfdsdlyc',
      }, {
        label: '2.每天的主食是否粗细搭配？',
        name: 'mtdzssfcxdp',
      },{
      //   label: '3.每天是否食用大于1斤的蔬菜？',
      //   name: 'mtsfsydy1jdsc',
      // },{
      //   label: '4.每周是否摄入深海鱼类？',
      //   name: 'mzsfsrshyl',
      // },{
        label: '3.每周是否摄入豆制品（如黄豆、豆腐、豆浆等）？',
        name: 'mzsfsrdzp',
      },{
        label: '4.是否有饮酒习惯（偶尔聚餐的饮酒不算习惯）？',
        name: 'sfyyjxg',
      },{
        label: '5.是否有吸烟习惯或长期吸二手烟？',
        name: 'sfyxyxghcqxesy',
      },{
        label: '6.是否经常吃咸辣等重口味食物（每周大于4次）？',
        name: 'sfjccxldzkwsw',
      },{
      //   label: '9.每日睡眠总量是否大于7小时？',
      //   name: 'mrsmzlsfdy7xs',
      // },{
        label: '7.每日活动量是否大于6000步？',
        name: 'mrhdlsfdy6000b',
      }],
      formData: {
      }
    }
  },
  created() {

  },
  mounted() {
    if(this.initdata){this.formData = {...this.initdata}}
  },
  methods: {
    onSubmit(values) {
      let query = { ...values }
      console.log('onSubmit', values, query);
      this.$emit('next-step',{type:'listStyleForm',data:query})
    },
    onClickPrev() {
      // this.$emit('prevStep')
      this.$router.back()
    }
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.bodyinfo-page {
  width: 100%;
  height: 100vh;
  padding: 2rem;
  background-color: #fff;
}

.bodyinfo-page .title {
  height: 2.33rem;
  font-weight: 500;
  font-size: 1.67rem;
  color: #333333;
  line-height: 2.33rem;
  margin-bottom: 2rem;
}

.form-wrapper {
  padding-bottom: 5rem;
}

.form-wrapper .form-item {
  margin-bottom: 2rem;
}

.form-wrapper .form-item .form-item-label {
  font-weight: 500;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  text-align: left;
  margin-bottom: 1rem;
}

.form-wrapper .form-item .form-item-input {
  /* width: 100%;
  height: 3.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  background: #F8F9FA; */
}

.icon-mark {
  width: 100px;
  font-size: 1.17rem;
}

.form-wrapper .form-item .form-item-input .van-cell {
  /* background: #F8F9FA; */
  padding-left: 0;
  border-bottom: 1px solid #e8e9ec;
}

.next-btn-wrapper {
  width: 100%;
  height: 6.9rem;
  display: flex;
  gap: 1.42rem;
  background-color: #fff;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  padding: 0.33rem 2rem;
  box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}

.form-wrapper .form-item .van-radio__label,
.bodyinfo-page .van-radio__label {
  font-size: 1.33rem;
  margin-bottom: 1rem;
}
</style>
